// extracted by mini-css-extract-plugin
export default {"view":"view__ksVv+","loaderBallz":"loaderBallz__z5d2w","childOne":"childOne__JX5y5","bouncing":"bouncing__5xe6f","childTwo":"childTwo__PYykd","childThree":"childThree__2uWZQ"};